import { render } from "./HistoryAndMemo.vue?vue&type=template&id=3946003e"
import script from "./HistoryAndMemo.vue?vue&type=script&lang=js"
export * from "./HistoryAndMemo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__